<div class="container">
    <div *ngIf="loadOffers" id="loadingPage"></div>
    <div class="row fam" *ngIf="!loadOffers">
        <div class="col-xs-6 fam-c" *ngFor="let b of bestSalesOffers;let i=index">
            <menu-card (OnAdd)="OpenMenuModal(i)" [menu]="b"></menu-card>
        </div>
    </div>
    <div *ngIf="bestSalesOffers.length==0 && !loadOffers">
        <div class="alert alert-danger text-center mt-2">
            Aucune offre disponible
        </div>
    </div>
</div>